/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_OptionalInputs */

const en_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const fr_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facultatif`)
};

const de_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const it_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzionale`)
};

const ru_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необязательный`)
};

const es_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional`)
};

const zh_cn2_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选修的`)
};

const ja_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプション`)
};

const hi_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वैकल्पिक`)
};

const pt_pt2_ad_section_optional = /** @type {(inputs: Ad_Section_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional`)
};

/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Ad_Section_OptionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_optional = /** @type {((inputs?: Ad_Section_OptionalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_OptionalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_optional(inputs)
	if (locale === "de") return de_ad_section_optional(inputs)
	if (locale === "it") return it_ad_section_optional(inputs)
	if (locale === "ru") return ru_ad_section_optional(inputs)
	if (locale === "es") return es_ad_section_optional(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_optional(inputs)
	if (locale === "ja") return ja_ad_section_optional(inputs)
	if (locale === "hi") return hi_ad_section_optional(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_optional(inputs)
	return en_ad_section_optional(inputs)
});